<template>
    <div class="main-content">
        <section class="non-app-page-width setting-profile-popup mfp-hide popup-save-document">
            <a @click="$router.go(-1)" class="profile-edit-close-btn">
                <img src="/assets/img/close-icon.svg"/>
            </a>
            <div class="setting-profile-wrapper">
                <div class="save-document-form add-project-document" v-if="!added">
                    <h2>Add this document to a Project</h2>
                    <form>
                        <div class="form-group" v-if="projects && projects.length">
                            <v-select
                                class="style-chooser" v-model="project_id"
                                placeholder="Select a project…"
                                label="name"
                                :options="projects"
                                :value="project_id"
                            />
                        </div>
                        <span class="invalid-feedback" v-if="exists">Document is already added to this project.</span>
                        <div class="form-group">
                            <input type="button" class="btn btn-primary mr-0 mt-3 mx-auto" @click="addDoc()" :disabled="!project_id" value="Add">
                        </div>
                    </form>
                </div>

                <div class="save-document-form add-project-document" v-else>
                    <h2>Document added!</h2>
                    <h4 v-if="project">You can now find it in the <router-link :to="{ name: 'Project View', params: {id : project.id} }" class="link">{{ project.name }}</router-link> Project folder</h4>
                    <div class="thanks-check">
                        <img src="/assets/img/check-icon-big.svg" alt="">
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import ApiService from "../../api/api.service";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
    name: "AddDocument",
    components: {
        vSelect
    },
    data() {
        return {
            project_id: null,
            projects: null,
            project: null,
            document_id: this.$route.query.document_id,
            added: false,
            exists: false,
        }
    },

    mounted() {
        if(this.$route.query.document_id) {
            this.getProjects();
        }
    },

    methods: {
        getProjects() {
            ApiService.setHeader();
            ApiService.get('/api/projects', )
                .then(({data}) => {
                    if(data.projects.length) {
                        this.projects = data.projects;
                    } else {
                        // redirect to create project page
                        this.$router.push({ name: 'Create Project Intro' });
                    }

                })
                .catch((response) => {
                    console.log(response);
                });
        },

        addDoc()
        {
            ApiService.setHeader();
            ApiService.post('/api/projects/add-doc', { document_id : this.document_id, project_id: this.project_id.id})
                .then(({data}) => {
                    if(data.success) {
                        this.project = data.project;
                        this.added = true;
                    } else {
                        this.exists = true;
                    }
                })
                .catch((response) => {
                    console.log(response);
                });
        }
    }
}
</script>

<style scoped>

.add-project-document h4 {
    font-weight: 500;
}

.add-project-document h4 a {
    text-decoration: underline;
    color: #23a6cd;
}

</style>
